import { provide, inject } from "vue";
import { useRoute } from "vue-router";
import { Module as CentralAdminModule } from "@/modules/centralAdmin/enums";
import { Module as CentralWebsiteModule } from "@/modules/centralWebsite/enums";
import { Module as TenantAdminModule } from "@/modules/tenantAdmin/enums";
import { Module as TenantWebsiteModule } from "@/modules/tenantWebsite/enums";
import { SharedModule } from "@/modules/shared/enums";

export type Module = (
  | CentralAdminModule
  | CentralWebsiteModule
  | TenantAdminModule
  | TenantWebsiteModule
) &
  SharedModule;

export const AllModules = [
  ...Object.values(CentralAdminModule),
  ...Object.values(CentralWebsiteModule),
  ...Object.values(TenantAdminModule),
  ...Object.values(TenantWebsiteModule),
  ...Object.values(SharedModule),
] as Module[];

interface Options {
  provide: boolean;
}

export const useModule = (
  forceModule?: string,
  options: Partial<Options> = {},
) => {
  const injectedModule = inject<string | undefined>("module", undefined);

  const route = useRoute();

  const module =
    forceModule ?? injectedModule ?? (route.meta.module as string | undefined);

  if (!module) throw new Error("Could not found module");

  if (options.provide) {
    provide("module", module);
  }

  return { module };
};
